import { Callback } from "game-common/models"

import { HudChip } from "./hud_chip"

// The way to say something from a device with no keyboard.
//
// Chat has always been opened with a key (Enter, or "/"), which leaves a phone with no way in at
// all -- and, because the log fades itself out after a few seconds, no way to get a conversation
// back either. This chip is both: it opens the composer (gui/chat_composer.ts), and it FLARES when
// a line lands while the composer is closed, which is the only notice a player who was looking
// somewhere else gets.
//
// It sits in the top-right row beside the items and map toggles, on the same argument the items
// chip is there for: a camp suppresses the control bar, and in a camp there is no keyboard to fall
// back on.
export class ChatChip extends HudChip {
    constructor(onClick: Callback) {
        super({ glyph: "💬", label: "SAY", onClick })
    }
}
